import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiCreateManagedUser } from '../../api/strapiUsers';
import { queryKeys } from '../queryKeys';

export function useCreateManagedUserMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      username: string;
      email: string;
      password: string;
      userTypeId: string;
      analisTypeDataIds?: string[];
    }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCreateManagedUser(jwt, input);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({
        queryKey: [...queryKeys.strapi, 'users'],
      });
    },
  });
}
